import { useSelector } from 'modules/react-redux';
import { memo } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { getActiveReportConfig } from '../../selectors/pageSelectors';
import { BrowserNewWindow } from '../BrowserNewWindow/BrowserNewWindow';
import { Content, Loading } from './components';
import { usePrintPreviewPopup } from './PrintPreviewPopup.hooks';
import { messages } from './PrintPreviewPopup.messages';

export const PrintPreviewPopup = memo(() => {
    const company = useCompanyBasedOnUrl();
    const reportConfig = useSelector(getActiveReportConfig);

    const { isAvailable, isLoading, handleClose } = usePrintPreviewPopup();

    if (!isAvailable || !reportConfig) {
        return null;
    }

    const reportName = reportConfig.name || messages.unnamedReportName;

    const title = messages.windowTitle({ companyName: company.displayName, reportName });

    return (
        <BrowserNewWindow title={title} onClose={handleClose}>
            {isLoading ? (
                <Loading />
            ) : (
                <Content company={company} reportConfig={reportConfig} reportName={reportName} />
            )}
        </BrowserNewWindow>
    );
});

PrintPreviewPopup.displayName = 'PrintPreviewPopup';
